import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../../../Localization.jsx"
import Helper from "../../../Helper.jsx";

import {
  Icon,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Slider,
  Button,
} from '@material-ui/core';

class ImageHolder extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      is360View: true,
      anchorEl: null,
      isQualityMenuOpen: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    let divHeight = this.refs.div.getBoundingClientRect().height;
    this.props.parent.props.parent.setState({
      imageHolderHeight: divHeight,
    });
    this.props.parent.props.parent.state.imageHolderHeight = divHeight;
  }

  sliderValueChanged = (event, value) => {
    this.props.parent.updatePlaybackTime(value);
  }

  switchViewClicked() {
    let view = !this.state.is360View;
    this.setState({
      is360View: view,
    });
    this.state.is360View = view;

    this.props.parent.refs.stageMediaImage.forceUpdate();
    this.props.parent.props.parent.refs.stageElementListView.forceUpdate();
  }

  newStageElementClicked() {
    // console.log(this.props.parent.props.parent.props.parent);
    this.props.parent.props.parent.props.parent.addStageElement();
  }

  stageHasFile() {
    let result = false;
    if (this.props.parent.props.parent.props.parent.state.selectedStage != null) {
      if (this.props.parent.props.parent.props.parent.state.selectedStage['movie_list'].length > 0) {
        result = true;
      }
    }
    return result;
  }

  handleQualityMenuOpen = event => {
    this.setState({
      isQualityMenuOpen: true,
      anchorEl: event.currentTarget,
    });

    this.state.isQualityMenuOpen = true;
    this.state.anchorEl = event.currentTarget;
  }

  handleMenuClose = () => {
    this.setState({
      isQualityMenuOpen: false,
    });
    this.state.isQualityMenuOpen = false;
  }

  handleQualityOptionClicked = (event, index) => {
    this.props.parent.setState({
      imageQuality: index,
    });
    this.handleMenuClose();
  }

  render() {
    let qualityOptions = [
      Localization.strings.ORIGINAL,
      Localization.strings.FAST,
    ];

    return (
      <div style={{display:'flex'}} ref="div">
        <div>
          {/* {Helper.fToHHMMSS(this.props.parent.state.playbackTime)} / {Helper.fToHHMMSS(this.props.parent.state.playbackDuration)} */}
          <Tooltip title={this.state.is360View? Localization.strings.FLAT_VIEW : Localization.strings.VIEW_360}>
            <IconButton onClick={this.switchViewClicked}>
              <Icon fontSize="small">{this.state.is360View? "crop_landscape" : "360"}</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title={Localization.strings.QUALITY}>
            <IconButton onClick={this.handleQualityMenuOpen}>
              <Icon>settings</Icon>
            </IconButton>
          </Tooltip>
          <Menu
            disableAutoFocusItem={true}
            anchorEl={this.state.anchorEl}
            transformOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={this.state.isQualityMenuOpen}
            onClose={this.handleMenuClose}
          >
            {qualityOptions.map((option, index) => (
              <MenuItem
                key={index}
                selected={index == this.props.parent.state.imageQuality}
                onClick={event => this.handleQualityOptionClicked(event, index)}
              >
                {option}
              </MenuItem>
            ))}
          </Menu>
          <Tooltip title={Localization.strings.NEW_STAGE_ELEMENT} style={{marginRight:"20px"}}>
            {/* <IconButton onClick={this.newStageElementClicked} disabled={!this.stageHasFile()}>
              <Icon>add</Icon>
            </IconButton> */}
            <Button color="primary" variant="contained" onClick={this.newStageElementClicked} disabled={!this.stageHasFile()}>
              <Icon>add</Icon>
              {Localization.strings.NEW_STAGE_ELEMENT}
            </Button>
          </Tooltip>
          {Helper.fToHHMMSS(this.props.parent.state.playbackTime)} / {Helper.fToHHMMSS(this.props.parent.state.playbackDuration)}
        </div>
        <div style={{flex: 1, padding:'9px 18px', margin:'auto'}}>
          <Slider
            value={this.props.parent.state.playbackTime}
            min={0}
            max={parseInt(this.props.parent.state.playbackDuration)}
            step={1}
            onChange={this.sliderValueChanged}
          />
        </div>
      </div>
    )
  }
}

export default ImageHolder;
